import type { V2AnnotationPayload } from '@/store/types'

export const isViewsAnnotation = (slotName: string, annotation: V2AnnotationPayload): boolean => {
  if (!annotation.context_keys) {
    return true
  }

  return !!annotation.context_keys?.slot_names?.includes(slotName)
}
